import LegalPage from "@/components/LegalPage";
import { CONTACT_EMAIL } from "@/lib/config";

export default function Shipping() {
    return (
        <LegalPage
            testId="shipping-page"
            eyebrow="Legal"
            title="Shipping & Delivery Policy"
            updated="June 2026"
            seoTitle="Shipping & Delivery Policy · Abhijit J K"
            seoDescription="Service delivery policy for digital consultation services by Abhijit J K, Founder of Ragi Media. No physical products are shipped."
            intro="Abhijit J K (Ragi Media) provides digital consultation services only. No physical products are sold or shipped. This policy explains how our service is delivered to you."
            sections={[
                {
                    heading: "Digital Service — No Physical Shipping",
                    body: "We do not sell or ship any physical goods. All services are delivered digitally as a scheduled online consultation.",
                },
                {
                    heading: "Service Delivery",
                    list: [
                        "After successful payment, you select an available slot via our scheduling calendar.",
                        "A booking confirmation and a Google Meet link are delivered electronically to your email and/or WhatsApp.",
                        "Confirmation is typically sent immediately and, in all cases, within 24 hours of a successful booking.",
                        "The consultation is conducted online via Google Meet at the scheduled time.",
                    ],
                },
                {
                    heading: "Delivery Issues",
                    body: `If you do not receive your booking confirmation or meeting link within 24 hours of payment, please contact us at ${CONTACT_EMAIL} and we will assist you promptly.`,
                },
                {
                    heading: "Contact",
                    body: `For any questions about service delivery, contact us at ${CONTACT_EMAIL}.`,
                },
            ]}
        />
    );
}
